<template>
  <swiper
    :modules="modules"
    :slides-per-view="1.5"
    :space-between="20"
    :speed="4000"
    :loop="true"
    :autoplay="{ delay: 0, disableOnInteraction: false, reverseDirection: reverse }"
    :breakpoints="breakpoints"
    navigation
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <img :src="item.pic" alt="photo">
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  border-radius: 1rem;
  overflow: hidden;
}
img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const breakpoints = {
      1600: {
        slidesPerView: 4.5,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 25,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
    };

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
      breakpoints,
    }
  },
}
</script>
